import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Snackbar,
  Menu,
  MenuItem,
  Stack,
  Typography,
  CircularProgress,
  Divider,
} from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import StopScreenShareOutlinedIcon from "@mui/icons-material/StopScreenShareOutlined";
import StreamingChat from "./StreamingChat";
import PanToolIcon from "@mui/icons-material/PanTool";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import { SocketContext } from "../../context/socket";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  copyToClipboard,
  dynamicLink,
  fullName,
  getUserDetail,
  isOwnerId,
  onShare,
  putRecors,
} from "../../constants/function";
import { Images } from "../../assets/common";
import OutsideClickHandler from "react-outside-click-handler";
import CircleIcon from "@mui/icons-material/Circle";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import notifier from "../Notifier";
import HttpService from "../../services/http-service";
import ApiService from "../../services/api-service";
import AWS from "aws-sdk";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { S3_BUCKET } from "../../constants/api";
import IosShareIcon from "@mui/icons-material/IosShare";
import DropMenu from "../DropMenu";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import VolumeOffRoundedIcon from "@mui/icons-material/VolumeOffRounded";
import { useTranslation } from "react-i18next";
import SongList from "./songList";
import MusicNoteAnimation from "./MusicNoteAnimation";
import { useSelector } from "react-redux";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
export default function StreamingControls({
  isMute,
  video,
  mute,
  disableVideo,
  isVideo,
  shareScreen,
  videoCall,
  playlistId,
  isOwner,
  leaveStreaming,
  tokenData,
  liveUser,
  stopShare,
  isFullScreen,
  onCloseFullScreen,
  role,
  isJoined,
  raisedList,
  hostMuted,
  streamData,
  switchAudio,
  mics,
  currentMic,
  handelFile,
  handleStopSong,
  play,
  liveUsers,
  cameras,
  currentCamera,
  switchVideo,
  userStream,
  obs,
}) {
  // const [songData, setSongData] = React.useState({});
  const { count } = useSelector((state) => state.adv);
  const [volume, setVolume] = React.useState(0);
  const [audienceStream, setAudienceStream] = React.useState(null);
  const [openMusic, setOpenMusic] = React.useState();
  const { t } = useTranslation("common");
  const [shareLink, setShareLink] = useState(streamData.shareUrl);
  const [option, setOption] = React.useState(false);
  const [started, setStarded] = React.useState(false);
  const [record, setRecord] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openSetting = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const user = getUserDetail();
  const [full, setFull] = React.useState(false);
  const socket = useContext(SocketContext).Socket;
  const [raised, setRaised] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [copied, setCopied] = React.useState(null);
  const [newRaised, setNewRaise] = React.useState(false);
  const [starting, setStarting] = React.useState(false);
  const [isflip, setIsFlip] = React.useState(false);

  const handleCopy = async (action) => {
    const url =
      shareLink && shareLink?.livestreamShortLink
        ? shareLink?.livestreamShortLink
        : shareLink ||
          (await dynamicLink(
            `/signup?returnUrl=/app/LiveVideoStreaming/${playlistId}?referralId=${user._id}`
          ));

    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: user._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: playlistId,
          sharedBy: fullName(user),
          eventValue: ["Livestream"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: user._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: playlistId,
          sharedBy: fullName(user),
          eventValue: ["Livestream"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  function openFullscreen() {
    var elem = document.getElementById("__steaming_container");
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      // setFull(true);
      onCloseFullScreen(true);
    }
  }
  /* Close fullscreen */
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      // setFull(false);
    }
  }

  useEffect(() => {
    if (socket) {
      socket.on("raised", function (data) {
        if (isOwner && data.channelName === playlistId && data.raised) {
          setNewRaise(true);
        }
      });
      socket.on("recording-started", function (data) {
        if (
          isOwner &&
          data.channelName === playlistId &&
          data.recordingStarted
        ) {
          setStarded(true);
          setStarting(false);
        }
      });
      socket.on("recording-stopped", function (data) {
        if (
          isOwner &&
          data.channelName === playlistId &&
          !data.recordingStopped
        ) {
          setStarded(false);
          setStarting(false);
        } else if (
          isOwner &&
          data.channelName === playlistId &&
          data.recordingStopped &&
          data.recordingUrl
        ) {
          setStarded(false);
          setStarting(false);
          // download(data.recordingKey);
        }
      });
      // socket.on("song-started", (data) => {
      //   if (data.roomId === playlistId) setSongData({ ...data });
      // });
    }
  }, [socket]);

  const download = async (url) => {
    try {
      const response = await ApiService.D_VIDEOS(url);
      AWS.config.update(response.result);
      var s3 = new AWS.S3();
      s3.getObject(
        {
          Bucket: S3_BUCKET,
          Key: url,
        },
        function (error, data) {
          if (error != null) {
            console.log("Failed to retrieve an object: " + error);
          } else {
            console.log(data);
            let blob = new Blob([data.Body], { type: data.ContentType });
            let urlCreator = window.URL || window.webkitURL;
            let videoUrl = urlCreator.createObjectURL(blob);
            let tag = document.createElement("a");
            tag.href = videoUrl;
            tag.target = "_blank";
            tag.download = "recording.mp4";
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
          }
        }
      );
    } catch (error) {}
  };

  function handleHandleraise() {
    socket.emit("raise", {
      raised: !raised,
      user: {
        userId: user._id,
        firstName: user.firstName,
        lastName: user.lastName,
        profileImg: user?.profileImg,
      },
      channelName: playlistId,
    });
    setRaised(!raised);
  }
  useEffect(() => {
    if (raisedList.length === 0) setOpen(false);
  }, [raisedList]);

  const handlleRedord = () => {
    if (socket) {
      if (!record) {
        socket.emit("start-recording", {
          channelName: playlistId,
          height: 640,
          width: 800,
        });
        setStarting(true);
      } else {
        socket.emit("stop-recording", {
          channelName: playlistId,
        });
        setStarting(true);
      }
      setRecord(!record);
    }
  };
  const doNothing = () => {};
  const handleClickShare = async (event) => {
    setOption(!option);
    const url =
      shareLink ||
      (await dynamicLink(
        `/signup?returnUrl=/app/LiveVideoStreaming/${playlistId}?referralId=${user._id}`
      ));
    putRecors({
      id: user._id,
      referralLink: url,
      eventType: ["click"],
      eventAsset: playlistId,
      sharedBy: fullName(user),
      eventValue: ["Livestream"],
      socialMedia: null,
    });
  };
  const handleCloseShare = () => {
    setOption(false);
  };
  useEffect(() => {
    if (!shareLink) getPlaylist();
  }, [shareLink]);
  const getPlaylist = async () => {
    const response = await ApiService.PLAYLIST_DETAIL({
      _id: playlistId,
      pageNo: 1,
      pageSize: 1,
    });
    setShareLink(response?.result?.shareUrl?.livestreamShortLink);
  };
  function onFileChooser(id) {
    document.getElementById(id).click();
  }
  const handleVolume = () => {
    if (userStream) {
      if (userStream?.audioTrack?._volume > 0 && count)
        userStream.audioTrack.setVolume(0);
      else if (userStream?.audioTrack?._volume === 0 && !count)
        userStream.audioTrack.setVolume(100);
      // setVolume(audienceStream.audioTrack._volume);
    }
  };
  useEffect(() => {
    setAudienceStream(userStream);
    if (count && userStream) handleVolume();
  }, [userStream]);

  useEffect(() => {
    if (!isOwner) handleVolume();
  }, [count]);

  const handleChange = (event) => {
    setIsFlip(event.target.checked);
  };

  const handleFlip = (event) => {
    if (socket) {
      // if (!isflip) {
      socket.emit("video-flip", {
        channelName: playlistId,
        isflip: !isflip, // Flip the value of isflip
      });
      setIsFlip(!isflip); // Flip the value of isflip in the state
      // }
    }
  };

  return (
    <Box
      id="_streaming_control"
      className="_streaming_control"
      // sx={{
      //   width:
      //     isOwner && liveUser > 0
      //       ? "85%"
      //       : isOwner && liveUser === 0
      //       ? "99%"
      //       : "99% !important",
      //   transition: "width 0.2s ease-in-out 0s",
      // }}
    >
      {/* Streaming chat */}
      {/* <Stack> */}
      {tokenData?.token ? (
        <StreamingChat
          streamData={streamData}
          isOwner={isOwner}
          playlistId={playlistId}
          closeFullscreen={() => closeFullscreen()}
          leaveStreaming={() => leaveStreaming()}
        />
      ) : null}
      {/* <StreamPlayer
        handleFile={(song, songs, index, prevIndex, restart) =>
          handelFile(song, songs, index, prevIndex, restart)
        }
      /> */}

      {isOwner ? (
        <Stack
          className="ml_auto streaming_control_box"
          direction="row"
          // spacing={1}
          alignItems="center"
        >
          {raisedList.length > 0 ? (
            <OutsideClickHandler
              onOutsideClick={() => {
                setOpen(false);
              }}
            >
              <Button
                sx={{ height: "30px !important", position: "relative" }}
                onClick={() => {
                  setOpen(!open);
                  setNewRaise(false);
                }}
                variant="outlined"
                color="primary"
                startIcon={
                  <PanToolIcon sx={{ fontSize: "13px" }} color="primary" />
                }
                endIcon={
                  newRaised ? <CircleIcon className="_new_raised_dot" /> : null
                }
              >
                list
              </Button>
            </OutsideClickHandler>
          ) : null}
          {isJoined ? (
            <IconButton className="btn" onClick={() => setOpenMusic(true)}>
              <img src={Images.allMusic} className="icon" alt="songs" />
            </IconButton>
          ) : null}

          {obs ? (
            <Tooltip title="Flip the screen" arrow placement="top">
              <Switch
                checked={isflip}
                onChange={handleChange}
                onClick={handleFlip}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Tooltip>
          ) : null}

          {!obs ? (
            starting ? (
              <IconButton className="btn">
                <CircularProgress
                  sx={{
                    width: "30px !important",
                    height: "initial !important",
                  }}
                  color="primary"
                />
              </IconButton>
            ) : (
              <IconButton
                onClick={handlleRedord}
                className="btn"
                disabled={starting}
                title={record ? t("stream.tooltip4") : t("stream.tooltip5")}
              >
                <RadioButtonCheckedIcon
                  sx={{
                    color: record ? "#E3293E" : "#ffffff",
                    fontSize: "18px",
                  }}
                />
              </IconButton>
            )
          ) : null}

          <Box sx={{ position: "relative" }}>
            <IconButton className="btn" onClick={handleClickShare}>
              <IosShareIcon className="icon" />
            </IconButton>
            {option ? (
              <OutsideClickHandler
                onOutsideClick={() => {
                  handleCloseShare();
                }}
              >
                <DropMenu
                  right={"0px"}
                  isHeader={true}
                  isLast={"-120px !important"}
                  actions={[
                    { key: "m14", action: t("dropMenu.m14") },
                    { key: "m15", action: t("dropMenu.m15") },
                    { key: "m16", action: t("dropMenu.m16") },
                    // "Share on Instagram",
                  ]}
                  toggleMenu={(action) => (
                    handleCopy(action), handleCloseShare()
                  )}
                />
              </OutsideClickHandler>
            ) : null}
          </Box>
          {!obs ? (
            <IconButton
              id="_share_screen_btn"
              className="btn"
              onClick={() => (isVideo ? shareScreen() : stopShare())}
              title={isVideo ? t("stream.tooltip6") : t("stream.tooltip7")}
            >
              {isVideo ? (
                <ScreenShareOutlinedIcon className="icon" />
              ) : (
                <StopScreenShareOutlinedIcon className="icon" />
              )}
            </IconButton>
          ) : null}

          {/* <IconButton className="btn" onClick={handleFull}>
            {full ? (
              <CloseFullscreenIcon className="icon" />
            ) : (
              <OpenInFullIcon className="icon" />
            )}
          </IconButton> */}
          {isJoined ? (
            <IconButton
              title={video ? t("stream.tooltip8") : t("stream.tooltip9")}
              onClick={disableVideo}
              className="btn"
              disabled={video === null}
            >
              {!video ? (
                <VideocamOffIcon className="icon" />
              ) : (
                <VideocamIcon className="icon" />
              )}
            </IconButton>
          ) : null}

          {isJoined ? (
            <IconButton
              title={isMute ? t("stream.tooltip10") : t("stream.tooltip11")}
              onClick={mute}
              className="btn"
            >
              {isMute ? (
                <MicOffIcon className="icon" />
              ) : (
                <MicIcon className="icon" />
              )}
            </IconButton>
          ) : null}
          {isJoined && mics.length > 0 ? (
            <Stack>
              <IconButton
                className="btn"
                onClick={handleClick}
                title={t("stream.tooltip12")}
              >
                <SettingsOutlinedIcon className="_cp icon" color="default" />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openSetting}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                // transformOrigin={{
                //   vertical: "top",
                //   horizontal: "left",
                // }}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {mics.map((mic, index) => (
                  <MenuItem
                    key={index}
                    selected={mic.label === currentMic.label}
                    onClick={() => {
                      handleClose();
                      switchAudio(mic.label);
                    }}
                  >
                    {mic.label}
                  </MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                {cameras.map((camera, index) => (
                  <MenuItem
                    key={index}
                    selected={camera.label === currentCamera.label}
                    onClick={() => {
                      handleClose();
                      switchVideo(camera.label);
                    }}
                  >
                    {camera.label}
                  </MenuItem>
                ))}
              </Menu>
            </Stack>
          ) : null}
        </Stack>
      ) : null}
      {/* Audience controls(leave and full screen) */}
      {!isOwner ? (
        <Stack
          className="streaming_control_box_audience"
          alignItems="center"
          direction="row"
          spacing={1}
          sx={{ position: "absolute", right: "11%", bottom: "19px" }}
        >
          {/* {songData?.song ? <MusicNoteAnimation song={songData} /> : null} */}
          {/*TODO: Host audio volume setting for audience */}
          {/* <IconButton onClick={() => handleVolume()}>
            {volume > 0 ? (
              <VolumeUpRoundedIcon sx={{ fontSize: "22px" }} color="default" />
            ) : (
              <VolumeOffRoundedIcon sx={{ fontSize: "22px" }} color="default" />
            )}
          </IconButton> */}

          {role === "host" && isJoined ? (
            <IconButton
              title={video ? t("stream.tooltip8") : t("stream.tooltip9")}
              onClick={disableVideo}
              className="btn"
              disabled={video === null}
            >
              {!video ? (
                <VideocamOffIcon className="icon" />
              ) : (
                <VideocamIcon className="icon" />
              )}
            </IconButton>
          ) : null}
          <Box sx={{ position: "relative" }}>
            <IconButton
              className="btn"
              sx={{ width: "30px", height: "30px", backgroundColor: "#353535" }}
              onClick={handleClickShare}
            >
              <IosShareIcon sx={{ fontSize: "18px" }} className="icon" />
            </IconButton>
            {option ? (
              <OutsideClickHandler
                onOutsideClick={() => {
                  handleCloseShare();
                }}
              >
                <DropMenu
                  right={"0px"}
                  isHeader={true}
                  isLast={"-120px !important"}
                  actions={[
                    { key: "m14", action: t("dropMenu.m14") },
                    {
                      key: "m15",
                      action: t("dropMenu.m15"),
                    },
                    {
                      key: "m16",
                      action: t("dropMenu.m16"),
                    },
                    // "Share on Instagram",
                    ,
                  ]}
                  toggleMenu={(action) => (
                    handleCopy(action), handleCloseShare()
                  )}
                />
              </OutsideClickHandler>
            ) : null}
          </Box>
          {role === "host" ? (
            <IconButton
              sx={{ cursor: hostMuted ? "not-allowed" : "pointer" }}
              title={
                hostMuted
                  ? t("stream.tooltip15")
                  : isMute
                  ? t("stream.tooltip10")
                  : t("stream.tooltip11")
              }
              onClick={() => (hostMuted ? doNothing() : mute())}
              className="btn"
            >
              {isMute ? (
                <MicOffIcon
                  sx={{
                    color: hostMuted ? "grey !important" : "#ffffff !important",
                  }}
                  className="icon"
                />
              ) : (
                <MicIcon className="icon" />
              )}
            </IconButton>
          ) : null}
          <IconButton onClick={handleHandleraise}>
            {raised ? (
              <PanToolIcon sx={{ fontSize: "16px" }} />
            ) : (
              <PanToolOutlinedIcon sx={{ fontSize: "16px" }} />
            )}
          </IconButton>
          <Button
            title={t("stream.button")}
            sx={{ height: "30px !important" }}
            onClick={() => leaveStreaming(raised)}
            variant="contained"
            color="error"
          >
            Leave
          </Button>
        </Stack>
      ) : null}
      {open ? (
        <Stack className="_raised_list" sx={{ position: "absolute" }}>
          {raisedList &&
            raisedList.map((raised, index) => (
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ padding: "5px 10px" }}
              >
                {raised?.user?.userId ? (
                  <Avatar
                    sx={{ width: 28, height: 28 }}
                    src={
                      raised?.user?.profileImg?.filePath ||
                      raised?.user?.profileImg ||
                      Images.default_user
                    }
                    alt={raised?.user?.firstName}
                  />
                ) : null}

                <Typography className="fs-14">
                  {fullName(raised?.user)}
                </Typography>
              </Stack>
            ))}
        </Stack>
      ) : null}
      {/* {started ? (
        <Snackbar
          sx={{ backgroundColor: "green", color: "black" }}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "botton", horizontal: "center" }}
          open={started}
          onClose={() => setStarded(false)}
          message={record ? t("recordingStart") : t("recoringStopped")}
        />
      ) : null} */}
      {openMusic ? (
        <SongList
          open={openMusic}
          liveUsers={liveUsers}
          roomId={playlistId}
          handleClose={(
            song,
            songs,
            index,
            prevIndex,
            restart,
            volume,
            preSong
          ) =>
            typeof index === "number"
              ? handelFile(
                  song,
                  songs,
                  index,
                  prevIndex,
                  restart,
                  volume,
                  preSong
                )
              : setOpenMusic(false)
          }
        />
      ) : null}
    </Box>
  );
}
